import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime-corejs2/helpers/asyncToGenerator";
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import adapter from 'webrtc-adapter';
import { validIP, isInnerIPFn } from '../helper/utils/common'; //获取RTC - 异步

export var getRTCConnect = function getRTCConnect() {
  return new _Promise(function (resolve, reject) {
    //创建实例，生成连接
    var ip_list = [],
        recode = {},
        RTCPeerConnection,
        pc,
        begin,
        reportStatus = false;
    var obj = {
      ethip: '',
      //内网
      rtc_ip: [],
      //外网映射ip
      ipv6: '',
      //ipv6
      ip: '',
      //外网
      ip_list: [] //获取到的所有ip数据

    };

    try {
      var gotDescription = function gotDescription(desc) {
        pc.setLocalDescription(desc);
      };

      var noDescription = function noDescription(error) {
        console.log('Error creating offer: ', error);
      };

      var iceCallback = function iceCallback(event) {
        if (event.candidate) {
          if (event.candidate.candidate === '') {
            return;
          }

          var candidate = event.candidate;
          var elapsed = ((window.performance.now() - begin) / 1000).toFixed(3);
          if (candidate.address) ip_list.push({
            address: candidate.address,
            type: candidate.type || '',
            time: elapsed
          });else if (candidate.candidate) handleCandidate(candidate.candidate, elapsed);
        } else if (!('onicegatheringstatechange' in RTCPeerConnection.prototype)) {
          //不支持onicegatheringstatechange 直接返回空串
          // should not be done if its done in the icegatheringstatechange callback.
          pc.close();
          pc = null;
          pc = null;
          reportStatus = true;
          resolve(validAddress(ip_list));
        }
      };

      var gatheringStateChange = function gatheringStateChange() {
        if (pc.iceGatheringState !== 'complete') {
          return;
        }

        reportStatus = true; //ICE协商已经转变为complete状态说明ICE收集已经完成

        resolve(validAddress(ip_list));
        pc.close();
        pc = null;
      };

      var iceCandidateError = function iceCandidateError(e) {// console.log(e)
      }; // 匹配字符串中符合ip地址的字段


      var handleCandidate = function handleCandidate(candidate, elapsed) {
        var ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3})/; // let ip_regex = /([0-9]{1,3}(\.[0-9]{1,3}){3}|([a-f0-9]{1,4}((:[a-f0-9]{1,4}){7}|:+[a-f0-9]{1,4}){6}))/

        var ip_isMatch = ip_regex.exec(candidate) !== null ? ip_regex.exec(candidate)[1] : '';

        if (!recode[ip_isMatch]) {
          ip_list.push({
            address: ip_isMatch,
            time: elapsed,
            type: candidate.indexOf('host') > -1 ? 'host' : 'srflx'
          });
          recode[ip_isMatch] = true;
        }
      };

      var validAddress = function validAddress(ip_arr) {
        var elapsed = ((window.performance.now() - begin) / 1000).toFixed(3);
        ip_arr.forEach(function (item) {
          var _item$type;

          var ip = item !== '' || item.address !== '' ? item.address ? item.address.replace(/\[|]/g, '') : '' : item.replace(/\[|]/g, '');
          if (validIP(ip, 'ipv6')) obj.ipv6 = ip;else if (item.type === 'host') obj.ethip = ip;else obj.rtc_ip.push(ip);
          obj.ip_list.push("".concat(elapsed, ": ").concat(ip, " ").concat((_item$type = item.type) !== null && _item$type !== void 0 ? _item$type : '-'));
        });
        return obj;
      }; //延迟


      RTCPeerConnection = window.RTCPeerConnection || window.mozRTCPeerConnection || window.webkitRTCPeerConnection; //不支持rtc直接返回空数组

      if (!RTCPeerConnection) resolve(obj);
      begin = window.performance.now();
      var config = {
        //防止出现一个不通的状况下，致使没法获取外网 IP 地址
        iceServers: [{
          urls: 'stun:stun.l.google.com:19302'
        }, {
          urls: 'stun:stun1.l.google.com:19302'
        }, {
          urls: 'stun:stun2.l.google.com:19302'
        }, // { urls: 'stun:stun3.l.google.com:19302' },
        // { urls: 'stun:stun4.l.google.com:19302' },
        {
          urls: 'stun:stun.services.mozilla.com:3478'
        }, {
          urls: 'stun:stun.qq.com:3478'
        } // { urls: 'stun:stun.xten.net:3478' },
        // { urls: 'stun:stun.voipstunt.com:3478' },
        // { urls: 'stun:stun.voxgratia.org:3478' },
        // { urls: 'stun:stun.xten.com:3478' },
        // { urls: 'stun:stun.rixtelecom.se:3478' },
        // { urls: 'stun:stun.fwdnet.net:3478' },
        // { urls: 'stun:stun.ideasip.com:3478' },
        // { urls: 'stun:stun.iptel.org:3478' },
        // { urls: 'stun:stun.voiparound.com:3478' },
        // { urls: 'stun:stun.softjoys.com:3478' },
        ],
        iceTransportPolicy: 'all',
        iceCandidatePoolSize: '0'
      };
      var offerOptions = {
        offerToReceiveAudio: 1
      };
      pc = new RTCPeerConnection(config);
      pc.onicecandidate = iceCallback;
      pc.onicegatheringstatechange = gatheringStateChange;
      pc.onicecandidateerror = iceCandidateError;
      pc.createOffer(offerOptions).then(gotDescription, noDescription);
      setTimeout(function () {
        if (!reportStatus) {
          reportStatus = true;
          resolve(validAddress(ip_list));
        }
      }, 5000);
    } catch (e) {
      reject(obj);
    }
  }).catch(function (e) {});
};
/**
 * Get the private IP address through webRTC
 * 通过WebRTC获取主机的网卡IP地址
 * @resolve IP
 */

export function getNetworkIP() {
  return _getNetworkIP.apply(this, arguments);
}

function _getNetworkIP() {
  _getNetworkIP = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var found, resolve, begin, promise, pc;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            found = false;
            begin = window.performance.now();
            promise = new _Promise(function (res) {
              resolve = res;
            });

            try {
              pc = new RTCPeerConnection({
                iceServers: []
              });
              pc.addEventListener('icecandidate', function (e) {
                if (!e.candidate || found) return;
                var elapsed = ((window.performance.now() - begin) / 1000).toFixed(3);
                resolve(elapsed + ': ' + e.candidate.address);
                found = true;
              });
              pc.createDataChannel('');
              pc.createOffer().then(function (desc) {
                return pc.setLocalDescription(desc);
              });
            } catch (e) {
              resolve('');
            }

            return _context.abrupt("return", promise);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _getNetworkIP.apply(this, arguments);
}